import { lazyWithPreload } from 'helpers/lazyWithPreload'

export const DoubleChinConcerns = lazyWithPreload(
  () => import('./DoubleChinConcerns'),
)
